import { Headline, Text } from '@awaze/design-system.components.text'
import {
  breakpoints,
  pxToRems,
  useWindowWidth,
} from '@awaze/design-system.utils.react'
import Image, { ImageLoader } from 'next/image'
import { Link } from '@awaze/design-system.components.link'
import { BlogTaggedArticle } from '@/components/tagged-articles/tagged-articles.module'
import { setImageParams } from 'src/utils/helpers/helpers'
import styled from 'styled-components'
import BlogTags from '@/components/BlogTags/BlogTags'

const BlogCardWithTagsContainer = styled.div`
  margin-bottom: ${pxToRems(32)};
  @media (min-width: ${breakpoints[0]}px) {
    margin-bottom: ${pxToRems(24)};
  }

  .headline {
    margin: ${pxToRems(16)} 0 ${pxToRems(8)};
  }
`

export default function BlogCardWithTags({
  link,
  imageUrl,
  title,
  description,
  tags,
  imageAltText,
}: Readonly<BlogTaggedArticle>): JSX.Element {
  const width = useWindowWidth()
  const isMobile = width < breakpoints[0]

  const imageHeight = isMobile ? '234' : '290'

  const customLoader: ImageLoader = ({ src }) =>
    setImageParams(src, {
      q: '95',
      fm: 'webp',
      w: '600',
      h: imageHeight,
    })

  return (
    <BlogCardWithTagsContainer>
      <Link href={link} underline={false} colourScheme="none">
        <Image
          src={imageUrl}
          alt={imageAltText}
          loader={customLoader}
          style={{
            borderRadius: 8,
            objectFit: 'cover',
            width: '100%',
            height: 'auto',
            aspectRatio: `${isMobile ? '9' : '7'}/5`, //height and aspect ratio only there to remove the Next/image warning
          }}
          width="380"
          height={imageHeight}
        />
        <Headline className="headline" as="h3" sizes={200} hasBorder={false}>
          {title}
        </Headline>
        <Text>{description}</Text>
      </Link>
      {Boolean(tags?.length) && <BlogTags tags={tags} />}
    </BlogCardWithTagsContainer>
  )
}
